import { render, staticRenderFns } from "./ReportAccidentDetails.vue?vue&type=template&id=8b289840&scoped=true&"
import script from "./ReportAccidentDetails.vue?vue&type=script&lang=ts&"
export * from "./ReportAccidentDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ReportAccidentDetails.vue?vue&type=style&index=0&id=8b289840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b289840",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VAutocomplete,VCard,VDatePicker,VForm,VMenu,VRadio,VRadioGroup,VTextField,VTextarea,VTimePicker})
